// src/components/Layout/Sidebar.tsx
import React, { useState, useEffect, useContext } from "react";
import { NavLink } from "react-router-dom";
import * as FaIcons from "react-icons/fa";
import "./Sidebar.css";
import { useAuth } from "../context/Auth/AuthContext";
import { jwtDecode } from "jwt-decode";

const Sidebar: React.FC = () => {
  const [isMobile, setIsMobile] = useState(false);
  const [open, setOpen] = useState(false);
  const { logout } = useAuth();

  const FaDashIcon = FaIcons.FaObjectGroup as unknown as React.FC<
    React.SVGProps<SVGSVGElement>
  >;
  const FaSearchIcon = FaIcons.FaSearch as unknown as React.FC<
    React.SVGProps<SVGSVGElement>
  >;
  const FaChartBarIcon = FaIcons.FaChartBar as unknown as React.FC<
    React.SVGProps<SVGSVGElement>
  >;
  const FaBoxIcon = FaIcons.FaBox as unknown as React.FC<
    React.SVGProps<SVGSVGElement>
  >;
  const FaSlidersIcon = FaIcons.FaSlidersH as unknown as React.FC<
    React.SVGProps<SVGSVGElement>
  >;
  const FaEnvelopeIcon = FaIcons.FaEnvelope as unknown as React.FC<
    React.SVGProps<SVGSVGElement>
  >;
  const FaBarsIcon = FaIcons.FaBars as unknown as React.FC<
    React.SVGProps<SVGSVGElement>
  >;

  const FaSignOutAltIcon = FaIcons.FaSignOutAlt as unknown as React.FC<
    React.SVGProps<SVGSVGElement>
  >;

  const FaHistoryIcon = FaIcons.FaHistory as unknown as React.FC<
    React.SVGProps<SVGSVGElement>
  >;

  let objUserTk: any;
  if (localStorage.getItem("token")) {
    objUserTk = jwtDecode(localStorage.getItem("token") || "") as any;
  } else {
    objUserTk = {};
  }

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
      {isMobile && (
        <button
          className="btn btn-dark position-fixed"
          style={{ top: 7, left: 6, zIndex: 1100 }}
          onClick={() => setOpen(!open)}
        >
          <FaBarsIcon style={{ marginBottom: "3px" }} />
        </button>
      )}

      <aside
        className={`sidebar d-flex flex-column p-4 ${open ? "open" : ""}`}
        style={{
          minWidth: "220px",
          maxWidth: "220px",
          backgroundColor: "#000",
          color: "#fff",
          minHeight: "100vh",
          position: isMobile ? "fixed" : "static",
          top: 0,
          left: 0,
          zIndex: 1000,
          transition: "transform 0.3s ease-in-out",
        }}
      >
        <div className="d-flex flex-column align-items-center">
          <div>
            <div
              className="logo text-end"
              style={{ fontSize: "37px", fontWeight: "500" }}
            >
              4Axon
            </div>
            <div
              className="logo mb-5 text-end"
              style={{
                marginTop: "-10px",
                color: "#78E01D",
                fontWeight: "500",
              }}
            >
              TECH
            </div>
          </div>
        </div>

        <nav className="nav flex-column gap-3">
          <NavLink
            to="/consult/cnpj"
            className={({ isActive }) =>
              isActive ? "nav-link active" : "nav-link"
            }
            style={({ isActive }) => ({
              color: isActive ? "#000" : "#78E01D",
              backgroundColor: isActive ? "#78E01D" : "transparent",
              borderRadius: "24px",
              padding: "10px 20px",
              textDecoration: "none",
              fontWeight: 500,
              display: "flex",
              alignItems: "center",
              gap: "8px",
              fontSize: "15px",
              transition: "background-color 0.3s ease, color 0.3s ease",
            })}
            onClick={() => isMobile && setOpen(false)}
          >
            <FaSearchIcon className="me-2" /> Nova Consulta - CNPJ
          </NavLink>

          <NavLink
            to="/consult/cpf"
            className={({ isActive }) => isActive ? "nav-link active" : "nav-link"}
            style={({ isActive }) => ({
              color: isActive ? "#000" : "#78E01D",
              backgroundColor: isActive ? "#78E01D" : "transparent",
              borderRadius: "24px",
              padding: "10px 20px",
              textDecoration: "none",
              fontWeight: 500,
              display: "flex",
              alignItems: "center",
              gap: "8px",
              fontSize: "15px",
              transition: "background-color 0.3s ease, color 0.3s ease",
            })}
            onClick={() => isMobile && setOpen(false)}
          >
            <FaSearchIcon className="me-2" /> Nova Consulta — CPF
          </NavLink>

          {/* <NavLink
            to="/dashboard"
            className={({ isActive }) =>
              isActive ? "nav-link active" : "nav-link"
            }
            style={({ isActive }) => ({
              color: isActive ? "#000" : "#78E01D",
              backgroundColor: isActive ? "#78E01D" : "transparent",
              borderRadius: "24px",
              padding: "10px 20px",
              textDecoration: "none",
              fontWeight: 500,
              display: "flex",
              alignItems: "center",
              gap: "8px",
              fontSize: "15px",
              transition: "background-color 0.3s ease, color 0.3s ease",
            })}
            onClick={() => isMobile && setOpen(false)}
          >
            <FaDashIcon className="me-2" /> Dashboard
          </NavLink> */}

          <NavLink
            to="/ocr"
            className={({ isActive }) =>
              isActive ? "nav-link active" : "nav-link"
            }
            style={({ isActive }) => ({
              color: isActive ? "#000" : "#78E01D",
              backgroundColor: isActive ? "#78E01D" : "transparent",
              borderRadius: "24px",
              padding: "10px 20px",
              textDecoration: "none",
              fontWeight: 500,
              display: "flex",
              alignItems: "center",
              gap: "8px",
              fontSize: "15px",
              transition: "background-color 0.3s ease, color 0.3s ease",
            })}
            onClick={() => isMobile && setOpen(false)}
          >
            <FaChartBarIcon className="me-2" /> OCR
          </NavLink>

          <NavLink
            to="/history"
            end
            className={({ isActive }) => (isActive ? "nav-link active" : "nav-link")}
            style={({ isActive }) => ({
              color: isActive ? "#000" : "#78E01D",
              backgroundColor: isActive ? "#78E01D" : "transparent",
              borderRadius: "24px",
              padding: "10px 20px",
              textDecoration: "none",
              fontWeight: 500,
              display: "flex",
              alignItems: "center",
              gap: "8px",
              fontSize: "15px",
              transition: "background-color 0.3s ease, color 0.3s ease",
            })}
            onClick={() => isMobile && setOpen(false)}
          >
            <FaHistoryIcon className="me-2" /> Históricos - CNPJ
          </NavLink>

          <NavLink
            to="/history/cpf"
            className={({ isActive }) => (isActive ? "nav-link active" : "nav-link")}
            style={({ isActive }) => ({
              color: isActive ? "#000" : "#78E01D",
              backgroundColor: isActive ? "#78E01D" : "transparent",
              borderRadius: "24px",
              padding: "10px 20px",
              textDecoration: "none",
              fontWeight: 500,
              display: "flex",
              alignItems: "center",
              gap: "8px",
              fontSize: "15px",
              transition: "background-color 0.3s ease, color 0.3s ease",
            })}
            onClick={() => isMobile && setOpen(false)}
          >
            <FaHistoryIcon className="me-2" /> Históricos - CPF
          </NavLink>

          {objUserTk.Rule === "Master4Axon" && (
            <NavLink
              to="/client"
              className={({ isActive }) =>
                isActive ? "nav-link active" : "nav-link"
              }
              style={({ isActive }) => ({
                color: isActive ? "#000" : "#78E01D",
                backgroundColor: isActive ? "#78E01D" : "transparent",
                borderRadius: "24px",
                padding: "10px 20px",
                textDecoration: "none",
                fontWeight: 500,
                display: "flex",
                alignItems: "center",
                gap: "8px",
                fontSize: "15px",
                transition: "background-color 0.3s ease, color 0.3s ease",
              })}
              onClick={() => isMobile && setOpen(false)}
            >
              <FaBoxIcon className="me-2" /> Clientes
            </NavLink>
          )}

          {objUserTk.Rule === "Master4Axon" && (
            <NavLink
              to="/configuration-screen"
              className={({ isActive }) =>
                isActive ? "nav-link active" : "nav-link"
              }
              style={({ isActive }) => ({
                color: isActive ? "#000" : "#78E01D",
                backgroundColor: isActive ? "#78E01D" : "transparent",
                borderRadius: "24px",
                padding: "10px 20px",
                textDecoration: "none",
                fontWeight: 500,
                display: "flex",
                alignItems: "center",
                gap: "8px",
                fontSize: "15px",
                transition: "background-color 0.3s ease, color 0.3s ease",
              })}
              onClick={() => isMobile && setOpen(false)}
            >
              <FaSlidersIcon className="me-2" /> Personalização
            </NavLink>
          )}

          {objUserTk.Rule === "Master" && (
            <NavLink
              to="/users"
              className={({ isActive }) =>
                isActive ? "nav-link active" : "nav-link"
              }
              style={({ isActive }) => ({
                color: isActive ? "#000" : "#78E01D",
                backgroundColor: isActive ? "#78E01D" : "transparent",
                borderRadius: "24px",
                padding: "10px 20px",
                textDecoration: "none",
                fontWeight: 500,
                display: "flex",
                alignItems: "center",
                gap: "8px",
                fontSize: "15px",
                transition: "background-color 0.3s ease, color 0.3s ease",
              })}
              onClick={() => isMobile && setOpen(false)}
            >
              <FaEnvelopeIcon className="me-2" /> Usuários
            </NavLink>
          )}

          <NavLink
            to="/login"
            className={({ isActive }) =>
              isActive ? "nav-link active" : "nav-link"
            }
            style={({ isActive }) => ({
              color: isActive ? "#000" : "#78E01D",
              backgroundColor: isActive ? "#78E01D" : "transparent",
              borderRadius: "24px",
              padding: "10px 20px",
              textDecoration: "none",
              fontWeight: 500,
              display: "flex",
              alignItems: "center",
              gap: "8px",
              fontSize: "15px",
              transition: "background-color 0.3s ease, color 0.3s ease",
            })}
            onClick={() => {
              isMobile && setOpen(false);
              logout();
            }}
          >
            <FaSignOutAltIcon className="me-2" /> Sair
          </NavLink>
        </nav>
      </aside>
    </>
  );
};

export default Sidebar;
